import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { DataEntity } from '@barthauer/abc/graphics/adapters/open-layers';
import { ResourceSet } from 'libs/abc/core/resources/src/lib/resource-set';
import { of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { BasysMapFrameService } from '../../basys-map-frame.service';
import { NamedObjectInfo } from '../../models/mapsData.model';
import { PanelComponent } from '../../shared/panel.component';

@Component({
    selector: 'app-object-info-panel',
    templateUrl: './object-info-panel.component.html',
    styleUrls: ['./object-info-panel.component.css'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ObjectInfoPanelComponent extends PanelComponent implements OnInit, OnDestroy {
  activeObjectInfo: NamedObjectInfo;
  scrollViewPortElementName: string = 'arena';
  public res = ResourceSet.Empty;

  constructor(frame: BasysMapFrameService, abcCore: AbcCore, private resourceService: ResourceManagerService) {
    super();
    super.init(frame);
    this.subscriptions.push(
      frame.lib
        .getObjectInfoData()
        .pipe(
          concatMap((objectInfos) => {
            if (objectInfos && objectInfos.length > 0) {
              const objectInfo: DataEntity = objectInfos[0];
              return abcCore.objectSpace.getObjectType(objectInfo.objectType).pipe(
                map((otvm) => {
                  const namedObjectInfo: NamedObjectInfo = new NamedObjectInfo();
                  namedObjectInfo.id = objectInfo.id;
                  namedObjectInfo.objectTypeName = otvm.name;
                  return namedObjectInfo;
                })
              );
            } else {
              return of(null);
            }
          })
        )
        .subscribe(
          (noi) => {
            if (noi) {
              this.activeObjectInfo = noi as NamedObjectInfo;
            }
          },
          (error) => {
            abcCore.error.publish(error);
          }
        )
    );
    this.subscriptions.push(
      abcCore.persist.afterPersistPendingChanges$.subscribe(
        (result) => {
          if (Array.isArray(result)) {
            const dataEntities = result.map((_) => new DataEntity(_.objectType, _.id));
            this.frame.map.refreshMapLayer(dataEntities);
          }
        },
        (err) => {
          abcCore.error.publish(err);
        }
      )
    );
  }

  ngOnDestroy(): void {
    console.log('ObjectInfoComponent ngOnDestroy');
    super.ngOnDestroy();
  }
  async ngOnInit() {
    super.ngOnInit();
    this.res = await this.resourceService.getResourceSet('basys-map-frame');
  }
}
